import React, { createContext, useCallback, useEffect, useState } from "react";
import axios from "axios";
import Router, { useRouter } from "next/router";
export const GlobalContext = createContext();
import { BASE_URL, MODE, PUSHER_APP_KEY } from "utils/Base";
import { api } from "api/base";
import { getReviewStatusCount } from "api";
import { toast } from "react-hot-toast";
import Pusher from "pusher-js";

export const GlobalProvider = ({ children }) => {
  const [isauth, setAuth] = useState(false);
  const [shop_token, setShopToken] = useState(null);
  const [isdemo, setIsDemo] = useState(false);
  const [shop_data, setShopData] = useState(null);
  const [shop_domain, setShopDomain] = useState(null);
  const [shop_host, setShopHost] = useState(null);
  const [onboard_data, setOnBoardData] = useState(null);
  const [onboard_status, setOnBoardStatus] = useState(1);
  const [three60_data, set360Data] = useState(null);
  const [refetchData, setRefetchData] = useState(false);
  const [alert360, setAlert360] = useState(false);
  const [modal360, setModal360] = useState(false);
  const [whatsappNotification, setWhatsappNotification] = useState([]);
  const [reviewStatus, setReviewStatus] = useState(false);
  const [reviewId, setReviewId] = useState({
    reviewId: null,
    customerId: null,
  });

  const router = useRouter();

  useEffect(() => {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var shop = url.searchParams.get("shop");
    var token = url.searchParams.get("token");
    var host = url.searchParams.get("host");

    if (token) {
      setShopToken(token);
      verifyToken(token, shop);
    }
    if (shop) {
      setShopDomain(shop);
    }
    if (host) {
      setShopHost(host);
    }
  }, []);

  const verifyToken = useCallback(
    (token = shop_token, shop = shop_domain) => {
      api
        .get("/verify-shop-auth", {
          params: {
            merchantToken: token,
            shop: shop,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            setOnBoardStatus(res.data.data.onbroardStatus);
            getInitData(res.data.data, token, res.data.data?.shopId, shop);
            setAlert360(res.data.data?.channelName == "WA" ? true : false);
            // setModal360(res.data.data?.channelName == "WA" ? true : false);
          }
        });
    },
    [shop_token, shop_data, shop_domain, onboard_status]
  );

  const getInitData = useCallback(
    (data, token, shopId, shop) => {
      getReviewStatusCount(token, shopId, shop).then((response) => {
        if (response.status == 200) {
          setShopData({ ...data, ...response.data });
          setAuth(true);
          setReviewStatus(response.data.reviewStatus);
        }
      });
    },
    [refetchData]
  );

  // useEffect(async () => {
  //   const auth = await shop_token;
  //   const shop = await shop_data?.shopId;
  //   if (auth && shop) {
  //     setToken(auth);
  //     setShopToken(shop);
  //     setAuth(true);
  //     console.log("token validation -->", merchant_token);
  //   }
  // }, [merchant_token == null]);

  // useEffect(() => {
  //   const demo = JSON.parse(localStorage.getItem("demo_account"));
  //   if (demo == true) {
  //     setIsDemo(true);
  //   } else {
  //     setIsDemo(false);
  //   }
  // }, []);

  // const api = axios.create({
  //   baseURL: BASE_URL,
  //   params: {
  //     merchantToken: shop_token,
  //     shopId: shop_data?.shopId,
  //   },
  //   validateStatus: function (status) {
  //     console.log(status, "STATUS");
  //     if (status == 200) {
  //       return true;
  //     } else if (status == 404) {
  //       return Router.push("/404");
  //     } else if (status == 500) {
  //       return Router.push("/500"); // Resolve only if the status code is less than 500
  //     } else if (status == 401) {
  //       return Router.push("/Login"); // Resolve only if the status code is less than 500
  //     }
  //   },
  // });

  // useEffect(() => {
  //   if (!shop_data) return;

  //   // Enable pusher logging - don't include this in production
  //   Pusher.logToConsole = MODE == "PRODUCTION" ? false : true;

  //   var pusher = new Pusher(PUSHER_APP_KEY, {
  //     cluster: "ap2",
  //   });

  //   var channel = pusher.subscribe(
  //     `whatsapp-notification-channel${"-" + shop_data?.shopId}`
  //   );
  //   channel.bind("wa-notification-received", function (data) {
  //     // if(data?.message?.reviewData?.length > 0){

  //     setWhatsappNotification([
  //       data?.message?.reviewData[0],
  //       ...whatsappNotification,
  //     ]);
  //     // whatsappNotification.unshift(data?.message?.reviewData[0]);
  //     // } ;
  //     // whatsappNotification.unshift(data?.message?.reviewData[0]);
  //     // toast.success(data?.message?.message,{position:"top-center"});
  //   });
  // }, [shop_data]);

  return (
    <GlobalContext.Provider
      value={{
        whatsappNotification,
        isauth,
        shop_token,
        isdemo,
        shop_data,
        onboard_data,
        setOnBoardData,
        onboard_status,
        setOnBoardStatus,
        three60_data,
        set360Data,
        refetchData,
        setRefetchData,
        shop_host,
        setShopData,
        alert360,
        setAlert360,
        modal360,
        setModal360,
        reviewStatus,
        setReviewStatus,
        reviewId,setReviewId
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
